import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=5c80d6f0&scoped=true&lang=pug&"
import script from "./ReviewItem.vue?vue&type=script&lang=js&"
export * from "./ReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItem.vue?vue&type=style&index=0&id=5c80d6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80d6f0",
  null
  
)

export default component.exports